import setFieldValue from "@iewccouk/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@iewccouk/Store/Reducers";
import {
    OwnProps,
    setRequestFormEffects,
} from "@iewccouk/Widgets/CreateAccount/FormBaseComponent";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TextField from "@insite/mobius/TextField";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    billingEmail: state.customCreateAccountForm.fieldValues.billingEmail,
    previouslyPurchased: state.customCreateAccountForm.fieldValues.previouslyPurchased,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const billingEmailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const BillingEmail: React.FC<Props> = ({billingEmail, previouslyPurchased, setFieldValue: widgetSetFieldValue }) => {
    const label = translate("Contact Email Address");
    const isRequired = true;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    const validateEmail = () => {
        let errorMessage: any = "";
        if (!billingEmail && isRequired) {
            errorMessage = siteMessage("Field_Required", label);
        } else if (billingEmail && !billingEmailRegexp.test(billingEmail)) {
            errorMessage = siteMessage("ContactUsForm_EmailIsInvalidErrorMessage");
        }

        setFieldErrorMessage(errorMessage as string);
        return !errorMessage;
    };

    setRequestFormEffects(isRequired, billingEmail, "billingEmail", validateEmail);

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "billingEmail", value: event.target.value });
    };

    const fieldBlurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
        validateEmail();
    };

    return (
        <TextField
            label={label}
            required={isRequired}
            value={billingEmail || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
            onBlur={fieldBlurHandler}
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingEmail);
